function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { StyledRedirectButton } from "./styles";
export const RedirectButton = ({
  children,
  className,
  onClick,
  url,
  ...props
}) => {
  const {
    handleRoutePush
  } = useSdkContext();
  return /*#__PURE__*/React.createElement(StyledRedirectButton, _extends({
    className: className,
    rel: "noreferrer",
    target: "_blank",
    onClick: event => {
      void handleRoutePush(url);
      onClick === null || onClick === void 0 || onClick(event);
    }
  }, props, {
    "data-qa": "redirect-button"
  }), children);
};
RedirectButton.displayName = "RedirectButton";